import React, { useEffect, Suspense, lazy } from 'react';
import { Hero } from './components/Hero';
import { HeroImage } from './components/HeroImage';
import { CountdownTimer } from './components/CountdownTimer';
import { MetaPixel } from './components/MetaPixel';
// Lazy-load EVERYTHING below the fold to minimize critical JS parse time
const PainPoints = lazy(() => import('./components/PainPoints').then(m => ({
  default: m.PainPoints
})));
const BookCTA = lazy(() => import('./components/BookCTA').then(m => ({
  default: m.BookCTA
})));
const LearningContent = lazy(() => import('./components/LearningContent').then(m => ({
  default: m.LearningContent
})));
const Benefits = lazy(() => import('./components/Benefits').then(m => ({
  default: m.Benefits
})));
const Bonuses = lazy(() => import('./components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const Testimonials = lazy(() => import('./components/Testimonials').then(m => ({
  default: m.Testimonials
})));
const Pricing = lazy(() => import('./components/Pricing').then(m => ({
  default: m.Pricing
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const StickyButton = lazy(() => import('./components/StickyButton').then(m => ({
  default: m.StickyButton
})));
const CountrySelector = lazy(() => import('./components/CountrySelector').then(m => ({
  default: m.CountrySelector
})));
const F = ({
  h = 500
}: {
  h?: number;
}) => <div style={{
  minHeight: h
}} data-id="element-0" />;
export function App() {
  // Defer scroll-reveal to AFTER first paint + idle
  useEffect(() => {
    const initReveal = () => {
      import('./hooks/useScrollRevealInit').then(m => m.initScrollReveal());
    };
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(initReveal, {
        timeout: 2000
      });
    } else {
      setTimeout(initReveal, 100);
    }
  }, []);
  return <div className="w-full min-h-screen bg-[var(--bg-darker)]" data-id="element-1">
      {/* Meta Pixel — init + PageView on mount */}
      <MetaPixel data-id="element-2" />

      <Suspense fallback={null} data-id="element-3">
        <CountrySelector position="top-right" data-id="element-4" />
      </Suspense>
      <CountdownTimer data-id="element-5" />

      <div className="pt-14 md:pt-16" data-id="element-6">
        <Hero data-id="element-7" />
        <HeroImage data-id="element-8" />

        <div className="cv-auto" data-id="element-9">
          <Suspense fallback={<F h={500} data-id="element-11" />} data-id="element-10">
            <PainPoints data-id="element-12" />
          </Suspense>
        </div>
        <div className="cv-auto" data-id="element-13">
          <Suspense fallback={<F h={600} data-id="element-15" />} data-id="element-14">
            <BookCTA data-id="element-16" />
          </Suspense>
        </div>
        <div className="cv-auto" data-id="element-17">
          <Suspense fallback={<F h={800} data-id="element-19" />} data-id="element-18">
            <LearningContent data-id="element-20" />
          </Suspense>
        </div>
        <div className="cv-auto" data-id="element-21">
          <Suspense fallback={<F h={600} data-id="element-23" />} data-id="element-22">
            <Benefits data-id="element-24" />
          </Suspense>
        </div>
        <div className="cv-auto" data-id="element-25">
          <Suspense fallback={<F h={2000} data-id="element-27" />} data-id="element-26">
            <Bonuses data-id="element-28" />
          </Suspense>
        </div>
        <div className="cv-auto" data-id="element-29">
          <Suspense fallback={<F h={700} data-id="element-31" />} data-id="element-30">
            <Testimonials data-id="element-32" />
          </Suspense>
        </div>
        <div className="cv-auto" data-id="element-33">
          <Suspense fallback={<F h={800} data-id="element-35" />} data-id="element-34">
            <Pricing data-id="element-36" />
          </Suspense>
        </div>
        <div className="cv-auto" data-id="element-37">
          <Suspense fallback={<F h={1000} data-id="element-39" />} data-id="element-38">
            <Guarantee data-id="element-40" />
          </Suspense>
        </div>
      </div>

      <Suspense fallback={null} data-id="element-41">
        <StickyButton data-id="element-42" />
      </Suspense>
    </div>;
}